import { render, staticRenderFns } from "./YoutubeIcon.vue?vue&type=template&id=0b8ce95d&scoped=true&"
import script from "./YoutubeIcon.vue?vue&type=script&lang=js&"
export * from "./YoutubeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ce95d",
  null
  
)

export default component.exports